import React from 'react'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export const ExportToExcel = ({ apiData, fileName,name }) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
  
    const exportToCSV = (apiData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(apiData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };
  
    return (
      <button onClick={(e) => exportToCSV(apiData, fileName)} style={{
    width:"100%",
      minWidth:"fit-content",
      border: `1px solid #410660`,
      color: "#fff",
      borderRadius: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "0.5rem",
      textTransform: "capitalize",
      padding: "7px 16px",
      fontWeight: 500,
      fontSize: "14px",
      color: "#fff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      backgroundColor: "#410660",
      cursor: "pointer",
      marginLeft:'10px'}}>{name}</button>
    );
  };